// extracted by mini-css-extract-plugin
export default {"loadingButton":"routerPrompt_loadingButton__ZRBwf"};